export default __webpack_public_path__ + "static/media/broken-file.95c4d7c3.svg";